import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { getMunicipalities, getMunicipality } from '../services/municipalitiesService';

const BASE = 'municipalities';

export const municipalitiesQueryKeys = {
    base: () => [BASE],
    detail: (id) => [BASE, 'detail', id],
    list: (data) => data ? [BASE, 'list', data] : [BASE, 'list'],
}

export const useGetMunicipality = (id, { enabled = true } = {}) => {
    return useQuery({
        queryKey: municipalitiesQueryKeys.detail(id),
        queryFn: () => getMunicipality(id),
        enabled: enabled && !!id,
        staleTime: Infinity, // Datos de baja frecuencia de cambio
    });
};

export const useGetMunicipalities = (data, { enabled = true } = {}) => {
    return useQuery({
        queryKey: municipalitiesQueryKeys.list(data),
        placeholderData: keepPreviousData,
        queryFn: () => getMunicipalities(data),
        enabled: enabled,
        staleTime: Infinity, // Datos de baja frecuencia de cambio
    });
};